var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-card',{attrs:{"table":"","title":"Zusammenfassung"}},[_c('table',{staticClass:"table table-sm table-striped"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Eindeutige Kennung")]),_c('td',[_vm._v(_vm._s(_vm.assessment.id))])]),_c('tr',[_c('td',[_vm._v("Erstellt")]),_c('td',[_vm._v(_vm._s(_vm.assessment.readableCreatedAt))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }